import { createBaseDatastreamNamedDtoSchema } from './create-base-datastream-named-dto-schema';

/**
 * Schema for a base datastream DTO (Data Transfer Object) with a name property.
 *
 * This constant is created using the `createBaseDatastreamNamedDtoSchema` factory function,
 * which defines the structure and validation rules for named datastream DTOs.
 *
 * @see createBaseDatastreamNamedDtoSchema
 */
export const BaseDatastreamNamedDtoSchema = createBaseDatastreamNamedDtoSchema();
